const gcfUrl = process.env.VUE_APP_GCF_URL;

export default `${gcfUrl}/api`;
